import React, { useContext } from 'react'
import { Modal, View } from 'oio-react'
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom'
import { LAYOUT_HEADER, LAYOUT_SIDEBAR } from 'config/constants/ui'
import InitiativeCheckInDesk from 'src/apps/CheckInDesk'
import EventSchedule from 'src/apps/Events/apps/View/Schedule'
import InitiativeFiles from 'src/apps/Initiative/apps/Files'
import InitiativePage from 'src/apps/Initiative/apps/Page'
import InitiativePeople from 'src/apps/Initiative/apps/People'
import InitiativeNav from 'src/apps/Initiative/components/Nav'
import InitiativeStatusBanner from 'src/apps/Initiative/components/StatusBanner'
import InitiativeJoin from 'src/components/Initiative/Join'
import ModalRoute from 'src/components/utils/ModalRoute'
import InitiativeSettings from 'src/legacy/5.6/InitiativeSettings'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'
import CoverA from '~/components/CoverA'
import ViewHome from './Home'

const InitiativeView = () => {
   const history = useHistory()
   const match = useRouteMatch()
   const { protoTheme: theme } = useContext(ProtoThemeContext)

   const { initiative } = useContext(InitiativeHierarchyContext)
   const isSidebarGL = theme.tmpGlobalLayout === LAYOUT_SIDEBAR
   const isHeaderGL = theme.tmpGlobalLayout === LAYOUT_HEADER

   return (
      <View
         position="relative"
         width="100%"
         height="100vh"
         backgroundColor={theme.tmpContentBackgroundColor}>
         <InitiativeStatusBanner />
         <View
            display="flex[d-f]"
            justifyContent="center"
            width="100%">
            <View
               display="block[a-d] flex[d-f]"
               width="100%"
               maxWidth={!isSidebarGL && theme.viewportContentMaxWidth}
               paddingRight={!isHeaderGL ? '30px[a-c]' : theme.tmpViewportPadding}
               paddingLeft={!isHeaderGL ? '30px[a-c]' : theme.tmpViewportPadding}>
               <View
                  display="flex"
                  width="100%"
                  flexFlow={isSidebarGL ? 'column[a-d] row[e-f]' : 'column[a-c] row[e-f]'}
                  scroll="on">
                  <View float="left" width="100%[a-d] 46%[e-f]">
                     {/* A safe cover design */}
                     <CoverA />
                     {/* A cover design that works well for nice CoverMedia
                     <EventCoverB />
                      */}
                  </View>
                  <View
                     display="flex"
                     justifyContent="center"
                     float="left"
                     width="100%[a-d] calc(100% - 46%)[e-f]"
                     backgroundColor={theme.tmpContentBackgroundColor}
                     borderLeft={`1px solid ${theme.tmpColumnBorderColor}[d-f]`}
                     padding={isSidebarGL
                        ? '10px 20px[a] 10px 40px[b] 10px 0px[c-d] 15px 40px[e-f]'
                        : '0px[a-c] 0px 0px 0px 30px[d] 10px 0px 0px 40px[e-f]'
                     }>
                     <View
                        float="left"
                        width="100%"
                        maxWidth={isSidebarGL && '550px[a-d]'}
                        minHeight="100vh">
                        <View display="block" height="60px" width="100%">
                           <InitiativeNav backgroundColor={theme.tmpContentBackgroundColor} />
                        </View>
                        <Switch>
                           <Route exact path={match.path} component={ViewHome} />
                           <Route path={`${match.path}/join`}>
                              <InitiativeJoin onClose={() => history.push(match.url)} />
                              <ViewHome />
                           </Route>
                           <Route
                              path={`${match.path}/files`}
                              component={InitiativeFiles}
                           />
                           <Route
                              path={`${match.path}/pages/:pageSlug`}
                              component={InitiativePage}
                           />
                           <Route
                              path={`${match.path}/people`}
                              component={InitiativePeople}
                           />
                           <Route
                              path={`${match.path}/schedule/:selectedDateKey?`}
                              component={EventSchedule}
                           />
                           {initiative.currentUserCanEdit && (
                              <>
                                 {initiative.class === 'event' && (
                                    <ModalRoute path={`${match.path}/checkin`}>
                                       {({ open, onCloseComplete, onCloseTrigger }) => (
                                          <Modal
                                             borderRadius="6px"
                                             overlayBackgroundColor="rgba(0,0,0,0.85)"
                                             width="100%"
                                             height="100%"
                                             onCloseComplete={onCloseComplete}
                                             onCloseTrigger={onCloseTrigger}
                                             open={open}>
                                             <InitiativeCheckInDesk returnUrl={match.url} />
                                          </Modal>
                                       )}
                                    </ModalRoute>
                                 )}
                                 <ModalRoute path={`${match.path}/settings`}>
                                    {({ open, onCloseComplete, onCloseTrigger }) => (
                                       <Modal
                                          borderRadius="3px"
                                          overlayBackgroundColor="rgba(45,40,40,0.9)"
                                          height="100%[a-b] 85%[c-f]"
                                          width="100%[a-b] 90%[c-d] 1200px[e-f]"
                                          onCloseComplete={onCloseComplete}
                                          onCloseTrigger={onCloseTrigger}
                                          open={open}>
                                          <InitiativeSettings returnUrl={match.url} />
                                       </Modal>
                                    )}
                                 </ModalRoute>
                              </>
                           )}
                        </Switch>
                        <View float="left" width="100%" height="50px" />
                     </View>
                  </View>
               </View>
            </View>
         </View>
      </View>
   )
}

export default InitiativeView
